import React, { useContext } from 'react';

import { Divider, Flex, Grid, GridItem, Text } from '@chakra-ui/react';

import { getFooterLinks } from './config';
import { FooterAppLinks } from './FooterAppLinks';
import { FooterCopyright } from './FooterCopyright';
import { FooterLink } from './FooterLink';
import { EColor } from '../../../Theme';
import { maxWidths } from '../../../utilities';
import { NavigationContext } from '../../context/NavigationContext';
import { useMonolithUrls } from '../../hooks/useMonolithUrls';

export function Footer() {
  const { fanaticsCollectUrl } = useMonolithUrls();
  const { fanaticsCollectBaseUrl } = useContext(NavigationContext);
  const footerLinks = getFooterLinks(
    fanaticsCollectBaseUrl ?? fanaticsCollectUrl
  );

  return (
    <Flex
      align="center"
      bg={EColor.Neutral50}
      flexDirection="column"
      justifyContent="flex-end"
      overflowX="hidden"
    >
      <Divider borderColor={EColor.Neutral10} orientation="horizontal" />

      <Grid
        maxW={maxWidths}
        templateColumns={{
          base: '1fr',
          sm: 'repeat(2, 1fr)',
          lg: 'repeat(4, 1fr)',
          xl: 'repeat(4, 1fr) auto',
        }}
        w="100%"
      >
        {footerLinks.map((footerLink) => (
          <Flex
            flexDirection="column"
            key={footerLink.name}
            px={{ base: '30px', sm: '16px' }}
            py="32px"
            rowGap="24px"
          >
            <Text fontSize="18px" fontWeight="700">
              {footerLink.name}
            </Text>

            <Flex flexDirection="column" gap="24px" transitionDuration="0.2s">
              {footerLink.items.map((link) => (
                <FooterLink
                  data-testid={`footer-link-${link.dataTestId}`}
                  href={link.path}
                  key={`inner-nav-${link.name}`}
                  name={link.name}
                />
              ))}
            </Flex>
          </Flex>
        ))}

        <GridItem gridColumn={{ base: '1 / -1', xl: 'auto' }}>
          <FooterAppLinks />
        </GridItem>
      </Grid>

      <FooterCopyright />
    </Flex>
  );
}
